import { gql } from "@apollo/client";

export const GET_TOOL_CONFIGS = gql`
  query ToolConfigs {
    toolConfigs {
      id
      unique_identifier
      fullName
      displayName
      category
      support
      pythonClass
      viewtypes
      color
    }
  }
`;
